import { Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import {TaskListDialogComponent} from '../task-list-dialog/task-list-dialog.component';

@Component({
  selector: 'app-task-list-item',
  templateUrl: './task-list-item.component.html',
  styleUrls: ['./task-list-item.component.css']
})
export class TaskListItemComponent implements OnInit {

  options: any
  today : any
  currentDate : any

  @Input() deviceXs: any;
  @Input() deviceLg: any;
  @Input() deviceMd: any;
  @Input() deviceXl: any;

  xl = {
    panelClass: ['animate__animated','animate__slideInRight'],
    position : {
      left : "30%"
    },
    width : "calc(100% - 100px)",
    height : "calc(100% - 0px)",
  }

  lg = {
    panelClass: ['animate__animated','animate__slideInRight'],
    position : {
      left : "30%"
    },
    width : "calc(100% - 100px)",
    height : "calc(100% - 0px)",
  }

  md = {
    panelClass: ['animate__animated','animate__slideInRight'],
    position : {
      left : "30%"
    },
    width : "calc(100% - 100px)",
    height : "calc(100% - 0px)",
  }

  sm = {
    panelClass: ['animate__animated','animate__slideInRight'],
    position : {
      left : "20%"
    },
    width : "calc(100% - 100px)",
    height : "calc(100% - 0px)",
  }

  xs = {
    panelClass: ['animate__animated','animate__slideInRight'],
    position : {
      left : "20%"
    },
    width : "calc(100% - 0px)",
    height : "calc(100% - 0px)",
  }

  constructor(private dialog : MatDialog) { }

  openTaskListItemDialog() {
    if(this.deviceLg){
      this.dialog.open(TaskListDialogComponent, this.lg)
    }
    if(this.deviceMd){
      this.dialog.open(TaskListDialogComponent, this.md)
    }
    if(this.deviceXs){
      this.dialog.open(TaskListDialogComponent, this.xs)
    }
    if(this.deviceXl){
      this.dialog.open(TaskListDialogComponent, this.xl)
    }
  }

  ngOnInit(): void {
    this.options = {
      month : 'short',
      day : 'numeric',
      year : 'numeric'
    }
  
    this.today = new Date();
    this.currentDate = this.today.toLocaleDateString("en-US",this.options)
  }

}
